import React from "react";
import { Route } from "react-router-dom";
import { RoutePathProps } from "../../../AppRoutes/types";
import { addChildRoute } from "../../../AppRoutes/utils";

import StorefrontIcon from '@mui/icons-material/Storefront';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import VendorList from "../pages/vendors/VendorList";
import VendorDetail from "../pages/vendors/VendorDetail";
import AddVendor from "../pages/vendors/AddVendor";
import EditVendor from "../pages/vendors/EditVendor";
import PriceList from "../pages/priceLists/PriceList";
import PriceListDetail from "../pages/priceLists/PriceListDetail";
import AddPriceList from "../pages/priceLists/AddPriceList";
import Vendor from "../pages/Vendor";
import UploadPriceList from "../pages/priceLists/UploadPriceList";
import AiImportPriceList from "../pages/priceLists/AiImportPriceList";

import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import AddEditDailyLedger from "../pages/dailyLedger/AddEditDailyLedger";
import DailyLedgerList from "../pages/dailyLedger/DailyLedgerList";


const vendor: RoutePathProps = {
  name: 'vendor',
  path: '/vendor',
  label: 'Vendor',
  visibleInNav: true,
  icon: StorefrontIcon,
  requiredPermission:'vendor:list',
  children: [
    {
      name: 'vendorDetail',
      path: '/:id', // relative to /cars
      label: 'Vendor Detail',
      icon: StorefrontIcon,
      requiredPermission:'vendor:read'
    },
    {
      name: 'addVendor',
      path: '/addVendor', // relative to /cars
      label: 'Add Vendor',
      icon: StorefrontIcon,
      requiredPermission:'vendor:create'
    },
    {
      name: 'editVendor',
      path: '/editVendor/:id', // relative to /cars
      label: 'Edit Vendor',
      icon: StorefrontIcon,
      requiredPermission:'vendor:update'
    },
    {
      name: "dailyLedger",
      path: "/dailyLedger/:vendorId",
      label: "Daily Ledger",
      icon: TextSnippetIcon,
      requiredPermission:'ledger:read'
    },
    {
      name: "addDailyLedger",
      path: "/dailyLedger/addDailyLedger/:vendorId",
      label: "Add Daily Ledger",
      icon: TextSnippetIcon,
      requiredPermission:'ledger:create'
    },
    {
      name: "editDailyLedger",
      path: "/dailyLedger/editDailyLedger/:vendorId/:ledgerId",
      label: "Edit Daily Ledger",
      icon: TextSnippetIcon,
      requiredPermission:'ledger:update'
    },
  ],
};

const priceList: RoutePathProps = {
  name: 'priceList',
  path: '/priceList',
  label: 'PriceList',
  visibleInNav: true,
  icon: RequestQuoteIcon,
  requiredPermission:'price-list:list',
  children: [
    {
      name: 'priceListDetail',
      path: '/:id', // relative to /categories
      label: 'Price List Detail',
      icon: RequestQuoteIcon,
      requiredPermission:'price-list:read'
    },
    {
      name: 'addPriceList',
      path: '/addPriceList', // relative to /categories
      label: 'Add Price List',
      icon: RequestQuoteIcon,
      requiredPermission:'price-list:create'
    },
    {
      name: 'editPriceList',
      path: '/editPriceList/:id', // relative to /categories
      label: 'Edit Price List',
      icon: RequestQuoteIcon,
      requiredPermission: 'price-list:update'
    },
    {
      name: 'uploadPriceList',
      path: '/uploadPriceList', // relative to /categories
      label: 'Upload Price List',
      icon: CloudUploadIcon,
      requiredPermission:'price-list:upload'
    },
    {
      name: 'aiImportPriceList',
      path: '/aiImportPriceList', // relative to /categories
      label: 'Ai Import Price List',
      icon: AutoAwesomeIcon,
      requiredPermission:'price-list:upload'
    },
  ],
};

const vendors: RoutePathProps = addChildRoute(
    {
    name: 'vendors',
    path: '/vendors',
    label: 'Vendors',
    visibleInNav: true,
    icon: StorefrontIcon,
    dummy: true,
    children: [vendor, priceList],
    requiredPermission:'vendor:list',
  },
  { vendor, priceList }
)

const VendorRoutes = (
  <>
    <Route path={vendors.path} element={<Vendor />} />

    <Route path={vendors.children?.[0].path} element={<VendorList />} />
    <Route path={vendors.children?.[0].children?.[0].path} element={<VendorDetail />} />
    <Route path={vendors.children?.[0].children?.[1].path} element={<AddVendor />} />
    <Route path={vendors.children?.[0].children?.[2].path} element={<EditVendor />} />
    <Route path={vendors.children?.[0].children?.[3].path} element={<DailyLedgerList />} />
    <Route path={vendors.children?.[0].children?.[4].path} element={<AddEditDailyLedger />} />
    <Route path={vendors.children?.[0].children?.[5].path} element={<AddEditDailyLedger />} />

    <Route path={vendors.children?.[1].path} element={<PriceList />} />
    <Route path={vendors.children?.[1].children?.[0].path} element={<PriceListDetail />} />
    <Route path={vendors.children?.[1].children?.[1].path} element={<AddPriceList />} />
    <Route path={vendors.children?.[1].children?.[2].path} element={<AddPriceList />} />
    <Route path={vendors.children?.[1].children?.[3].path} element={<UploadPriceList />} />
    <Route path={vendors.children?.[1].children?.[4].path} element={<AiImportPriceList />} />

  </>
);

export const vendorPaths = [vendors];
export default VendorRoutes;